// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var AdminUserRole = function (x) {
    return x;
};
var tsBridgeAdminUserRole = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("AdminUserRole")("__brandAdminUserRole"));
    }
};
var writeAdminUserRole = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showAdminUserRole = Data_Show.showString;
var readAdminUserRole = Simple_JSON.readString;
var ordAdminUserRole = Data_Ord.ordString;
var newtypeAdminUserRole = {
    Coercible0: function () {
        return undefined;
    }
};
var makeAdminUserRole = AdminUserRole;
var eqAdminUserRole = Data_Eq.eqString;
export {
    AdminUserRole,
    makeAdminUserRole,
    unwrap,
    newtypeAdminUserRole,
    eqAdminUserRole,
    ordAdminUserRole,
    showAdminUserRole,
    readAdminUserRole,
    writeAdminUserRole,
    tsBridgeAdminUserRole
};
//# sourceMappingURL=index.js.map
